import * as React from 'react';
import { ArticleHeading2, ArticleHeading3, ArticleParagraph1, Image } from '@cian/ui-kit';
import { clsx } from 'clsx';

import { PromoItemLabel } from './parts';
import * as styles from './PromoItem.css';
import { IPromo } from '../../types/promosPage';

interface IPromoItemProps {
  promo: IPromo;
  isCoPromo?: boolean;
  stretchTopContent?: boolean;
  bottomContent: React.ReactNode;
  onClick?(): void;
}

export const PromoItem = React.forwardRef<HTMLDivElement, IPromoItemProps>(
  ({ promo, isCoPromo = false, stretchTopContent = true, bottomContent, onClick }, ref) => {
    const ArticleHeading = isCoPromo ? ArticleHeading2 : ArticleHeading3;

    return (
      <article
        ref={ref}
        className={clsx(styles['card'], { [styles['co-promo']]: isCoPromo })}
        onClick={onClick}
        role="button"
        tabIndex={0}
        data-testid="PromoItem"
      >
        <div className={clsx(styles['top-content'], { [styles['stretch-top-content']]: stretchTopContent })}>
          <div>
            <div className={styles['labels']}>
              {promo.labels.map(({ text, type }) => (
                <PromoItemLabel key={type} newbuildingIds={promo.newbuildingIds} text={text} type={type} />
              ))}
            </div>
            <ArticleHeading as="h3" data-testid="PromoItemHeading">
              {promo.name}
            </ArticleHeading>
            <div className={styles['provider']}>
              <ArticleParagraph1>{promo.providerName}</ArticleParagraph1>
            </div>
          </div>
          <div className={styles['logo']}>
            <Image
              src={promo.providerLogo}
              height="100%"
              width="100%"
              objectFit="contain"
              data-testid="PromoItemProviderLogo"
            />
          </div>
        </div>
        {bottomContent}
      </article>
    );
  },
);

PromoItem.displayName = 'PromoItem';
